import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../Layout/Logo';
import { MobileNavigation } from './MobileNavigation';
import { DesktopNavigation } from './DesktopNavigation';
import { Button } from '../ui/Button';

export function TopNav() {
  return (
    <header className="fixed top-0 left-0 right-0 z-40">
      {/* Gradient line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      
      {/* Glass background */}
      <div className="absolute inset-0 bg-gray-900/95 backdrop-blur-lg -z-10" />

      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex-shrink-0 relative group">
              <Logo />
              <div className="absolute inset-0 bg-blue-500/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity" />
            </Link>
            <DesktopNavigation />
          </div>

          <div className="flex items-center gap-4">
            <Link
              to="/blog"
              className="hidden lg:block nav-item"
            >
              Blog
            </Link>
            <Link
              to="/contact"
              className="hidden lg:inline-flex"
            >
              <Button>Contact Us</Button>
            </Link>
            <MobileNavigation />
          </div>
        </div>
      </div>
    </header>
  );
}